import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import CarroPage from './pages/CarroPage';
import CaminhaoPage from './pages/CaminhaoPage';
import ImovelPage from './pages/ImovelPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/about" element={<App />} />
        <Route path="/carro" element={<CarroPage />} />
        <Route path="/caminhao" element={<CaminhaoPage />} />
        <Route path="/" element={<ImovelPage />} />
      </Routes>
    </Router>
  </React.StrictMode>
);